import { useCallback } from 'react';
import { useNavigateKeepSearch } from '@hooks/useNavigateKeepSearch';
import { STEPS } from '../constants';

export function useNavigateToNextStep() {
  const navigateKeepSearch = useNavigateKeepSearch();
  return useCallback(
    (step: STEPS) => {
      navigateKeepSearch(step === STEPS.START ? '/setup' : `/setup/${step}`);
    },
    [navigateKeepSearch],
  );
}
